import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
export default class MagicSlider extends Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "index", 0);
    _defineProperty(this, "interval", void 0);
    _defineProperty(this, "touchStartX", null);
    _defineProperty(this, "isMobile", typeof window !== 'undefined' && !!window.matchMedia && window.matchMedia('(max-width: 768px)').matches);
    _defineProperty(this, "mq", void 0);
    _defineProperty(this, "mqHandler", void 0);
  }
  oncreate(vnode) {
    const ms = Number(vnode.attrs.autoplayMs || 0);
    if (vnode.attrs.slides.length > 1 && ms > 0) {
      this.interval = window.setInterval(() => {
        this.next(vnode.attrs.slides.length);
        m.redraw();
      }, ms);
    }
    if (window.matchMedia) {
      this.mq = window.matchMedia('(max-width: 768px)');
      this.mqHandler = () => {
        var _this$mq;
        this.isMobile = !!((_this$mq = this.mq) != null && _this$mq.matches);
        m.redraw();
      };
      this.mq.addEventListener ? this.mq.addEventListener('change', this.mqHandler) : this.mq.addListener(this.mqHandler);
    }
  }
  onremove() {
    if (this.interval) {
      window.clearInterval(this.interval);
      this.interval = undefined;
    }
    if (this.mq && this.mqHandler) {
      this.mq.removeEventListener ? this.mq.removeEventListener('change', this.mqHandler) : this.mq.removeListener(this.mqHandler);
      this.mqHandler = undefined;
    }
  }
  next(len) {
    this.index = (this.index + 1) % len;
  }
  prev(len) {
    this.index = (this.index - 1 + len) % len;
  }
  onPointerDown(e) {
    var _e$clientX;
    this.touchStartX = (_e$clientX = e.clientX) != null ? _e$clientX : 0;
  }
  onPointerUp(e, len) {
    var _e$clientX2;
    if (this.touchStartX === null) return;
    const dx = ((_e$clientX2 = e.clientX) != null ? _e$clientX2 : 0) - this.touchStartX;
    this.touchStartX = null;
    if (Math.abs(dx) > 40) {
      dx < 0 ? this.next(len) : this.prev(len);
      m.redraw();
    }
  }
  slideLinkLabel(i, total, hasLink) {
    return hasLink ? "Open slide ".concat(i + 1, " of ").concat(total) : "Slide ".concat(i + 1, " of ").concat(total);
  }

  /**
   * Best-effort, fire-and-forget — never blocks or delays the actual
   * navigation the visitor just triggered by clicking the slide, and never
   * surfaces an error if it fails (there's no UI here to show one in, and a
   * missed click count isn't worth interrupting anything over).
   */
  recordClick(id) {
    if (!id) return;
    app.request({
      method: 'POST',
      url: "".concat(app.forum.attribute('apiUrl'), "/forumaker/magicslider/click"),
      body: {
        id
      },
      background: true
    }).catch(() => {});
  }
  slideButtonLabel(i, active) {
    return active ? "Current slide ".concat(i + 1) : "Go to slide ".concat(i + 1);
  }
  viewInner(vnode) {
    const _vnode$attrs = vnode.attrs,
      slides = _vnode$attrs.slides,
      heightDesktop = _vnode$attrs.heightDesktop,
      heightMobile = _vnode$attrs.heightMobile,
      paddingDesktop = _vnode$attrs.paddingDesktop,
      paddingMobile = _vnode$attrs.paddingMobile,
      radiusDesktop = _vnode$attrs.radiusDesktop,
      radiusMobile = _vnode$attrs.radiusMobile;
    if (!slides.length) return null;
    if (this.index >= slides.length) {
      this.index = 0;
    }
    const offsetPct = -(this.index * 100);
    const pad = this.isMobile ? paddingMobile : paddingDesktop;
    const rad = this.isMobile ? radiusMobile : radiusDesktop;
    return m("div", {
      className: "MagicSlider-wrap",
      style: {
        padding: "".concat(pad, "px")
      }
    }, m("div", {
      className: "MagicSlider",
      style: {
        borderRadius: "".concat(rad, "px"),
        ['--ms-h-desktop']: "".concat(heightDesktop, "px"),
        ['--ms-h-mobile']: "".concat(heightMobile, "px")
      },
      onpointerdown: e => this.onPointerDown(e),
      onpointerup: e => this.onPointerUp(e, slides.length),
      "aria-label": "Homepage slider"
    }, m("div", {
      className: "MagicSlider-track",
      style: {
        transform: "translateX(".concat(offsetPct, "%)")
      }
    }, slides.map((s, i) => {
      const isFirst = i === 0;
      const label = this.slideLinkLabel(i, slides.length, !!s.link);
      const image = m("img", {
        className: "MagicSlide-image",
        src: s.image,
        alt: "",
        "aria-hidden": "true",
        draggable: false,
        fetchpriority: isFirst ? 'high' : 'low',
        loading: isFirst ? 'eager' : 'lazy',
        decoding: "async"
      });
      if (s.link) {
        return m("a", {
          key: i,
          className: "MagicSlide",
          href: s.link,
          target: s.newTab ? '_blank' : '_self',
          rel: s.newTab ? 'noopener noreferrer' : undefined,
          "aria-label": label,
          onclick: () => s.id && this.recordClick(s.id)
        }, image);
      }
      return m("div", {
        key: i,
        className: "MagicSlide",
        "aria-label": label
      }, image);
    })), slides.length > 1 && m('[', null, m("button", {
      type: "button",
      className: "MagicSlider-btn prev",
      "aria-label": "Previous slide",
      onclick: () => {
        this.prev(slides.length);
        m.redraw();
      }
    }, m("span", {
      className: "MagicSlider-btnVisual"
    }, m("i", {
      className: "fas fa-chevron-left"
    }))), m("button", {
      type: "button",
      className: "MagicSlider-btn next",
      "aria-label": "Next slide",
      onclick: () => {
        this.next(slides.length);
        m.redraw();
      }
    }, m("span", {
      className: "MagicSlider-btnVisual"
    }, m("i", {
      className: "fas fa-chevron-right"
    }))), m("div", {
      className: "MagicSlider-dots",
      "aria-label": "Slider pagination"
    }, slides.map((_, i) => {
      const isActive = this.index === i;
      return m("button", {
        key: i,
        type: "button",
        className: 'dot' + (isActive ? ' is-active' : ''),
        "aria-label": this.slideButtonLabel(i, isActive),
        "aria-current": isActive ? 'true' : 'false',
        onclick: () => {
          this.index = i;
          m.redraw();
        }
      }, m("span", {
        className: "dotInner",
        "aria-hidden": "true"
      }));
    })))));
  }
  view(vnode) {
    const fitToLayout = vnode.attrs.fitToLayout;
    if (fitToLayout) {
      return m("div", {
        className: "MagicSlider-outer"
      }, m("div", {
        className: "container"
      }, m("div", {
        className: "sideNavOffset"
      }, this.viewInner(vnode))));
    }
    return this.viewInner(vnode);
  }
}
flarum.reg.add('forumaker-magicslider', 'forum/components/MagicSlider', MagicSlider);